export default __webpack_public_path__ + "static/media/spurnest_logo_half.10e98a86.png";